  <ion-toolbar class="add-margin-top-to-safe-area" style="text-align: center">
   
    <ion-buttons slot="end">
      <ion-button (click)="back()"
        ><ion-icon color="dark" name="close"></ion-icon
      ></ion-button>
    </ion-buttons>

  </ion-toolbar>
<ion-content>
  <app-realtimeparking></app-realtimeparking>
</ion-content>
<ion-footer class="ion-no-border add-margin-bottom-to-safe-area" ></ion-footer>